var _g, _path, _rect, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 214,
    viewBox: "0 0 424 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3503_65124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4185 40.3582C86.4185 33.533 91.9514 28 98.7767 28H373.642C380.467 28 386 33.533 386 40.3582V120.173H98.7767C91.9514 120.173 86.4185 114.64 86.4185 107.814V40.3582Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.222 147.171C300.222 140.345 294.689 134.812 287.863 134.812H12.3584C5.53311 134.812 0.000152588 140.345 0.000152588 147.171V214.001H287.863C294.689 214.001 300.222 208.468 300.222 201.642V147.171Z",
    fill: "#F2F4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.2417,
    y: 156.914,
    width: 94.2562,
    height: 9.97352,
    rx: 4.98676,
    fill: "#C1C5D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 102.56,
    height: 9.20792,
    rx: 4.60396,
    transform: "matrix(-1 0 0 1 363.622 55.625)",
    fill: "#C1C5D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2417,
    y: 182.695,
    width: 227.225,
    height: 9.97352,
    rx: 4.98676,
    fill: "#C1C5D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 248.009,
    height: 9.20792,
    rx: 4.60396,
    transform: "matrix(-1 0 0 1 363.622 81.4062)",
    fill: "#C1C5D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3503_65124",
    x: 49.3438,
    y: 0.81194,
    width: 373.731,
    height: 166.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.88657
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.5373
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.309804 0 0 0 0 0.447059 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3503_65124"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3503_65124",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.b7fe380e667b3594cec3fad91af561b3.svg";
export { ForwardRef as ReactComponent };